import React from 'react'
import { Box, Button, FormControl, Grid, TextField } from '@mui/material'
import { ArrowRightCircle } from 'react-feather'

export const ManagementInfoStep = ({ useFetchInit }) => {

    const { 
        //------------- Generales
        // location,
        // paramsURL,
        //------------- globalStates
        // globalStates,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        Actions,
        //------------- helpers
        // Helpers,
        //------------- Formularios
        Forms
        
    } = useFetchInit

    // ------------------------------------------------ Generales
        
    // ------------------------------------------------ globalStates
    
    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    const { FormRequestGlobal } = Forms
    const { formState, onInputNumberChange } = FormRequestGlobal
    
    // ------------------------------------------------ FetchData
    
    // ------------------------------------------------ Actions
    const {
        handleChangeLegalizationAmount,
        handleChangeLegalizationExoneration,
        handleClickUpdateCostsLegalization,
        handleClickLoadLegalizationPayment
    } = Actions

    return (
            <>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={6} md={3} lg={3} sx={{ mb: 1, mt: 2 }}>
                        <FormControl fullWidth>
                            <label htmlFor="meses_ampliacion"> * Cantidad de meses a ampliar</label>
                            <TextField
                                id='meses_ampliacion'
                                name='meses_ampliacion'
                                value={ formState.meses_ampliacion } 
                                onChange={ onInputNumberChange }
                                size='small'
                                placeholder='Cantidad de meses a ampliar'
                                type='number'
                                steps='1'
                                min='0'
                                max='1000'
                                variant={(formState.idgestion > 0)? 'filled': 'outlined'}
                                hiddenLabel
                                InputProps={{
                                    readOnly: (formState.idgestion > 0) ? true: false 
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={3} sx={{ mb: 1, mt: 2 }}>
                        <FormControl fullWidth>
                            <label htmlFor="legalizacion_monto"> * Costo legalización</label>
                            <TextField
                                id='legalizacion_monto'
                                name='legalizacion_monto'
                                value={ formState.legalizacion_monto } 
                                onChange={ handleChangeLegalizationAmount }
                                size='small'
                                placeholder='Costo legalización'
                                type='number'
                                steps='1'
                                min='0'
                                max='1000'
                                variant='outlined'
                                hiddenLabel
                                InputProps={{
                                    readOnly: false
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={3} sx={{ mb: 1, mt: 2 }}>
                        <FormControl fullWidth>
                            <label htmlFor="legalizacion_exoneracion"> * Monto a exonerar</label>
                            <TextField
                                id='legalizacion_exoneracion'
                                name='legalizacion_exoneracion'
                                value={ formState.legalizacion_exoneracion } 
                                onChange={ handleChangeLegalizationExoneration }
                                size='small'
                                placeholder='Monto a exonerar'
                                type='number'
                                steps='1'
                                min='0'
                                max='1000'
                                variant='outlined'
                                hiddenLabel
                                InputProps={{
                                    readOnly: false
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={3} sx={{ mb: 1, mt: 2 }}>
                        <FormControl fullWidth>
                            <label htmlFor="legalizacion_pago"> * Monto a pagar</label>
                            <TextField
                                id='legalizacion_pago'
                                name='legalizacion_pago'
                                value={ formState.legalizacion_pago } 
                                onChange={ onInputNumberChange }
                                size='small'
                                placeholder='Monto a pagar'
                                type='number'
                                steps='1'
                                min='0'
                                max='1000'
                                variant={'filled'}
                                hiddenLabel
                                InputProps={{
                                    readOnly: true
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <div className="pt-4"></div>
                <Box className="text-center" sx={{mt: 2}}>
                    <Button 
                        endIcon={<ArrowRightCircle/>}
                        variant="outlined"
                        type="button" 
                        className='btn-round'
                        color='warning'
                        onClick={ async () => {
                            await handleClickUpdateCostsLegalization(formState.idgestion)
                            await handleClickLoadLegalizationPayment(formState.idgestion)
                        }} 
                        sx={{ marginRight: 1, marginLeft: 1 }}
                    >
                        Guardar & Continuar
                    </Button>
                </Box>
                
            </>
        )
}
